import "./IndustryHeroStyles.scss";
import $ from "jquery";
const industryHero = () => {
    $(() => {
        // Corrects hero text overflow (mobile)
        $("h1.title").html((_, html) => html.replace(/&nbsp;/g, " "));
    });
};
export { industryHero };
